import React from 'react'
import ReportHubPhoneNumberPage from "./ReportHubPhoneNumberPage"

function ReportHubPhoneNumberContainer() {
    return (
        <div className="ReportByDayContainer">
            <ReportHubPhoneNumberPage />
        </div>
    )
}

export default ReportHubPhoneNumberContainer
